// extracted by mini-css-extract-plugin
export default {"departments":"IG-z","departmentHeading":"JG-z","departmentSection":"KG-z","departmentName":"LG-z","departmentLink":"MG-z","expandIcon":"NG-z"};